import { render, staticRenderFns } from "./IconFavorite.vue?vue&type=template&id=5cc59a98&scoped=true"
import script from "./IconFavorite.vue?vue&type=script&lang=js"
export * from "./IconFavorite.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cc59a98",
  null
  
)

export default component.exports